export var facility = function facility(centralApi) {
  return {
    putTextingLocalStatus: function putTextingLocalStatus(status) {
      return centralApi.put('/facility', {
        textingLocalStatus: status
      });
    },
    putCommunicationsEnabled: function putCommunicationsEnabled(enabled) {
      return centralApi.put('/facility', {
        communicationsEnabled: enabled
      });
    },
    putAudioCallEnabled: function putAudioCallEnabled(enabled) {
      return centralApi.put('/facility', {
        audioCallingEnabled: enabled
      });
    },
    putVideoCallEnabled: function putVideoCallEnabled(enabled) {
      return centralApi.put('/facility', {
        videoCallingEnabled: enabled
      });
    },
    putMusicEnabled: function putMusicEnabled(enabled) {
      return centralApi.put('/facility', {
        musicEnabled: enabled
      });
    },
    putReferenceMaterialEnabled: function putReferenceMaterialEnabled(enabled) {
      return centralApi.put('/facility', {
        referenceMaterialEnabled: enabled
      });
    }
  };
};